<template>
  <v-col cols="12">
    <div class="login-guide white--text text-center mb-8">
      {{ $t('login.password_change_required') }}
    </div>

    <v-alert
      v-if="error"
      :class="uiComponentProperties.rounded ? 'rounded-b-pill rounded-t-pill' : uiComponentProperties.outlined ? 'rounded-0' : ''"
      :text="uiComponentProperties.text"
      :value="true"
      class="text-left"
      type="error"
    >
      {{ error }}
    </v-alert>

    <v-text-field
      v-model="password"
      :color="uiComponentProperties.inputColor"
      :label="$t('login.new_password')"
      :outlined="uiComponentProperties.outlined"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      autofocus
      class="mb-8"
      hide-details
      type="password"
    />
    <v-text-field
      v-model="passwordConfirm"
      :color="uiComponentProperties.inputColor"
      :label="$t('login.new_password_again')"
      :outlined="uiComponentProperties.outlined"
      :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
      class="mb-8"
      hide-details
      type="password"
      v-on:keyup.enter="change"
    />

    <div
      v-for="attribute in requiredAttributesList"
      :key="attribute"
      class="mb-4"
    >
      <v-text-field
        v-model="requiredAttributes[attribute]"
        :label="attribute.charAt(0).toUpperCase() + attribute.slice(1)"
        :placeholder="attribute.charAt(0).toUpperCase() + attribute.slice(1)"
        :color="uiComponentProperties.inputColor"
        :outlined="uiComponentProperties.outlined"
        :rounded="uiComponentProperties.rounded && uiComponentProperties.outlined"
        hide-details
      />
    </div>

    <div class="text-center">
      <v-btn
        :class="uiComponentProperties.buttonClass"
        :color="uiComponentProperties.buttonColor"
        :rounded="uiComponentProperties.rounded"
        :loading="loading"
        block
        class="font-weight-bold"
        large
        @click="change"
      >
        <v-icon left>mdi mdi-send</v-icon>
        {{ $t('login.change_password') }}
      </v-btn>
      <v-btn :rounded="uiComponentProperties.rounded" block class="mt-5" color="primary lighten-5" large text
             @click="signIn">
        <v-icon left>mdi mdi-arrow-left</v-icon>
        {{ $t('login.back_to_sign_in') }}
      </v-btn>
    </div>
  </v-col>
</template>
<script>
import UiEventBus from '@/UiEventBus';
import CognitoService from '@/service/cognito.service';

export default {
  name: 'RequireNewPassword',
  props: ['requireNewPasswordConfig', 'uiComponentProperties'],
  data() {
    return {
      error: '',
      password: '',
      passwordConfirm: '',
      loading: false,
      requiredAttributes: {},
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$t('login.new_password'),
        user: null,
        requiredAttributes: [],
      };
      return Object.assign(defaults, this.requireNewPasswordConfig || {});
    },
    requiredAttributesList() {
      // Handle both old Amplify format and new CognitoService format
      if (this.options.user?.challengeParam?.requiredAttributes) {
        return this.options.user.challengeParam.requiredAttributes;
      }
      if (this.options.requiredAttributes) {
        return this.options.requiredAttributes;
      }
      return [];
    },
  },
  methods: {
    setError(e) {
      if (!e) {
        this.error = '';
        return;
      }
      this.error = CognitoService.translate(e.message || e);
      console.error(this.error);
    },
    async change() {
      if (this.password !== this.passwordConfirm) {
        this.setError(this.$t('login.passwords_do_not_match'));
        return;
      }

      if (!this.options.user) {
        this.setError('User session not found. Please sign in again.');
        return;
      }

      this.loading = true;
      try {
        const result = await CognitoService.completeNewPasswordChallenge(
          this.options.user,
          this.password,
          this.requiredAttributes
        );

        if (result.challengeName === 'SMS_MFA') {
          UiEventBus.$emit('localUser', result);
          UiEventBus.$emit('authState', 'confirmSignIn');
        } else if (result.challengeName === 'MFA_SETUP') {
          UiEventBus.$emit('localUser', result);
          UiEventBus.$emit('authState', 'setMfa');
        } else {
          // Success - user is now signed in
          UiEventBus.$emit('localUser', result);
          UiEventBus.$emit('authState', 'signedIn');
        }
        this.setError(false);
      } catch (err) {
        this.setError(err);
      }
      this.loading = false;
    },
    signIn() {
      UiEventBus.$emit('authState', 'signIn');
    },
  },
};
</script>
